import $$ from 'cmn-utils'

const baseUrl = "/api/inspect/task/";
export default {
    create: (params) => {
        return $$.post(baseUrl + 'create', params)
    },
    delete: (params) => {
        return $$.post(baseUrl + 'delete', params)
    },
    get: (params) => {
        return $$.get(baseUrl + 'get', params)
    },
    list: async (params) => {
        return $$.get(baseUrl + 'list', params)
    },
    device: {
        get: (params) => {
            return $$.get(baseUrl + 'device/get', params)
        },
        list: (params) => {
            Object.keys(params).map(key => {
                if (!params[key] || params[key] == 'null' || params[key] == 'undefined') delete params[key]
            })
            return $$.get(baseUrl + 'device/list', params)
        },
        submit: (params) => {
            return $$.post(baseUrl + 'device/submit', params)
        },
    }

}